function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 800,
  width: 800,
  viewBox: "0 0 512 512",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#f4f4f5"
  },
  d: "M426.655 444.491c-85.064 74.278-206.9 83.839-299.319 29.581a245.76 245.76 0 0 1-60.958-50.499C56 411.723 46.93 399.058 39.085 385.82 15.143 345.045 3.539 298.958 3.784 252.953c.49-71.582 29.989-142.754 87.026-192.6C138.776 18.433 197.855-1.096 256.69.047c45.597.817 91.03 13.973 131.069 38.733 22.063 13.564 42.41 30.724 60.305 51.153 9.724 11.114 18.386 22.799 25.822 34.974 63.737 102.878 47.231 236.971-47.231 319.584z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#ededec"
  },
  d: "M107.7 89.244c99.915-87.35 248.817-74.175 333.815 23.051 84.998 97.226 75.388 243.379-24.528 330.729-99.915 87.35-251.727 82.317-336.725-14.908S7.784 176.594 107.7 89.244z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#d8d8d8"
  },
  d: "M244.029 141.49c-17.92 37.27-63.032 51.341-100.302 33.421-37.27-17.92-53.234-61.357-35.315-98.627 17.92-37.27 62.835-54.046 100.105-36.126s53.431 64.062 35.512 101.332z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 0.06,
    fill: "#040000"
  },
  d: "M128.086 97.65c17.92-37.27 62.835-54.046 100.105-36.126a73.797 73.797 0 0 1 11.586 6.942c-7.335-11.909-17.95-21.909-31.26-28.308-37.27-17.92-82.185-1.144-100.105 36.126-15.805 32.872-5.247 70.538 23.036 91.265-12.485-20.458-14.659-46.403-3.362-69.899z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#d8d8d8"
  },
  d: "M217.121 218.367c-1.17-5.733 2.71-11.178 8.442-12.348 5.733-1.17 11.248 2.359 12.418 8.091 1.17 5.733-2.456 11.466-8.189 12.635-5.732 1.171-11.501-2.646-12.671-8.378z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 0.5,
    fill: "#fff"
  },
  d: "M363.151 96.945c-1.17-5.733 2.71-11.178 8.442-12.348s11.248 2.359 12.418 8.091c1.17 5.733-2.456 11.466-8.189 12.636-5.733 1.169-11.502-2.647-12.671-8.379z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#d8d8d8"
  },
  d: "M282.752 398.389c8.691-7.598 21.813-6.256 29.411 2.435 7.598 8.691 6.926 21.591-1.765 29.189-8.691 7.598-22.059 6.972-29.657-1.719-7.598-8.691-6.68-22.307 2.011-29.905z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 0.5,
    fill: "#fff"
  },
  d: "M58.327 220.961c-1.17-5.733 2.71-11.178 8.442-12.348 5.733-1.17 11.248 2.359 12.418 8.091s-2.456 11.466-8.189 12.636c-5.733 1.17-11.502-2.646-12.671-8.379z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#d8d8d8"
  },
  d: "M468.947 281.701c-3.725 36.649-37.256 62.098-73.905 58.373-36.649-3.725-63.177-35.279-59.452-71.928 3.725-36.649 36.272-64.305 72.921-60.58 36.649 3.726 64.162 37.486 60.436 74.135zM173.239 331.136c14.631 25.328 4.867 57.294-20.461 71.925s-57.07 6.642-71.701-18.686c-14.631-25.328-6.526-58.257 18.802-72.888 25.327-14.632 58.729-5.679 73.36 19.649z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 0.06,
    fill: "#040000"
  },
  d: "M112.818 324.329c18.464-10.666 41.21-8.787 57.855 2.82-15.693-22.238-46.847-29.497-70.794-15.663-25.328 14.631-33.433 47.561-18.802 72.888 4.04 6.993 9.388 12.657 15.541 16.895a53.747 53.747 0 0 1-2.602-4.052c-14.631-25.327-6.526-58.257 18.802-72.888zM349.701 282.093c3.725-36.649 36.272-64.305 72.921-60.579 12.217 1.242 23.415 5.824 32.783 12.735-11.007-14.534-27.694-24.73-46.893-26.682-36.649-3.725-69.196 23.93-72.921 60.579-2.465 24.247 8.316 46.261 26.506 59.464-9.32-12.55-14.128-28.482-12.396-45.517z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 0.1,
    fill: "#040000"
  },
  d: "M254.81 381.707c-105.358 0-198.419-52.064-254.72-131.654-2.703 99.72 55.552 194.334 153.936 236.742 128.773 55.507 279.648 1.534 335.155-127.239 15.267-35.419 21.657-72.747 20.288-109.416-56.307 79.54-149.339 131.567-254.659 131.567z"
}));
export { SvgMoon as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/moon.svg";